import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EffectsModule } from '@ngrx/effects';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap';

import { ChassisResourceModule } from '@kaiser-software/chassis-resource';
import { ChassisNovaModule } from '@kaiser-software/chassis-nova';

import { CreatePage } from './pages/create/create.page';
import { ElementComponent } from './components/element/element.component';
import { FieldService } from './services/field.service';
import { FormComponent } from './components/form/form.component';
import { IdComponent as IdDetailComponent } from './components/elements/detail/id/id.component';
import { IdComponent as IdInputComponent } from './components/elements/input/id/id.component';
import { IndexPage } from './pages/index/index.page';
import { PasswordComponent as PasswordDetailComponent } from './components/elements/detail/password/password.component';
import { PasswordComponent as PasswordInputComponent } from './components/elements/input/password/password.component';
import { ResourceFormComponent } from './components/resource-form/resource-form.component';
import { TextComponent as TextDetailComponent } from './components/elements/detail/text/text.component';
import { TextComponent as TextInputComponent } from './components/elements/input/text/text.component';
import { LabelComponent } from './components/elements/label/label.component';
import { EditComponent } from './components/actions/edit/edit.component';
import { ShowComponent } from './components/actions/show/show.component';
import { DeleteComponent } from './components/actions/delete/delete.component';
import { ChassisLocalizationModule } from '@kaiser-software/chassis-localization';

@NgModule({
    imports: [
        CommonModule,
        ChassisResourceModule,
        ChassisNovaModule,
        EffectsModule.forFeature([
            // ResourceEffects
        ]),
        TabsModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        TooltipModule.forRoot(),
        ChassisLocalizationModule,
    ],
    exports: [],
    declarations: [
        CreatePage,
        DeleteComponent,
        ElementComponent,
        EditComponent,
        FormComponent,
        IdDetailComponent,
        IdInputComponent,
        IndexPage,
        LabelComponent,
        PasswordDetailComponent,
        PasswordInputComponent,
        ResourceFormComponent,
        ShowComponent,
        TextDetailComponent,
        TextInputComponent,
    ],
    entryComponents: [
        CreatePage,
        DeleteComponent,
        ElementComponent,
        EditComponent,
        FormComponent,
        IdDetailComponent,
        IdInputComponent,
        IndexPage,
        LabelComponent,
        PasswordDetailComponent,
        PasswordInputComponent,
        ResourceFormComponent,
        ShowComponent,
        TextDetailComponent,
        TextInputComponent,
    ],
    providers: [],
})
export class CoreResourcesModule {
    public constructor(
        protected injector: Injector,
        protected fieldService: FieldService,
    ) {

        // const resourceService: ResourceService = injector.get(ResourceService);
        //
        // resourceService.register('user', 'User', {
        //     icon: 'fas fa-user'
        // });
        //
        // resourceService.register('role', 'Role', {
        //     icon: 'fas fa-user-shield'
        // });

        this.fieldService
            .register('id', {
                detail: IdDetailComponent,
                input: IdInputComponent,
                // datatable: Type<any>
            })
            .register('text', {
                detail: TextDetailComponent,
                input: TextInputComponent,
                // datatable: Type<any>
            })
            .register('password', {
                detail: PasswordDetailComponent,
                input: PasswordInputComponent,
                // datatable: Type<any>
            });
    }

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreResourcesModule,
            providers: [
                FieldService,
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/chassis-resources.module.ts